import APIService from "@/services/APIService.js"; 

export default {
  getAllValoresUnitarios() {
    return APIService.apiCall().get("/valoresUnitarios/getAllValoresUnitarios");
  },
  getValoresUnitarios(id) {
    return APIService.apiCall().get(`/valoresUnitarios/getValoresUnitarios/${id}`);
  },
  getValoresPadroes() {
    return APIService.apiCall().get(`/valoresUnitarios/getValoresPadroes`);
  },
  getArquivoPadrao() {
    return APIService.apiCall().get(`/valoresUnitarios/getArquivoPadrao/`, { responseType: "blob" });
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/valoresUnitarios/salvar/${id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/valoresUnitarios/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/valoresUnitarios/baixar/${id}`, { responseType: "blob", ...config });
  },
  getJsonValores(postData) {
    return APIService.apiCall().post(`/valoresUnitarios/getJsonFromFile`, JSON.stringify(postData));
  }
};